// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"389":"669714ef","453":"ddef09fb","897":"fd1df2cf"}[chunkId] + ".chunk.js";
};